export const hasMarketplace = (traits) => {
  return traits && traits.some(trait => trait.name === 'Marketplace');
}

export const hasShipyard = (traits) => {
  return traits && traits.some(trait => trait.name === 'Shipyard');
}

export const isJumpGate = (waypoint) => {
  return waypoint && waypoint.type == 'JUMP_GATE';
}

export const atWaypoint = (ship, waypoint) => {
  if (!ship || !waypoint) {
    return false;
  }

  return waypoint.symbol == ship.nav.waypointSymbol;
}

export const canExtract = (traits) => {
  return traits && traits.some(trait => trait.symbol.indexOf('DEPOSITS') !== -1);
}

export const isInOrbit = (ship) => {
  if (!ship) {
    return false;
  }

  return ship.nav.status == 'IN_ORBIT';
}

export const isDocked = (ship) => {
  if (!ship) {
    return false;
  }

  return ship.nav.status == 'DOCKED';
}

export const unitsToPercentage = (current, max) => {
  return 100 * current / max;
}

export const isHQ = (waypoint, agent) => {
  return waypoint.symbol == agent.headquarters;
}

export const format = (dateString) => {
  const date = new Date(dateString);

  return (date.getDate().toString()).padStart(2, '0') + '-' +
    (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
    date.getFullYear().toString().padStart(4, '0') + ' ' +
    date.getHours().toString().padStart(2, '0') + ':' +
    date.getMinutes().toString().padStart(2, '0');
}

export const formatTime = (dateString) => {
  const date = new Date(dateString);

  return date.getHours().toString().padStart(2, '0') + ':' +date.getMinutes().toString().padStart(2, '0');
}

export const hasCargo = (cargo, symbol) => {
  return cargo.find((c) => c.symbol == symbol) !== undefined;
}

export const getCargoUnits = (cargo, symbol) => {
  if (cargo.find((c) => c.symbol == symbol)) {
    return cargo.find((c) => c.symbol == symbol).units;
  }
  return 0;
}

export const canDeliver = (contracts, waypoint, ship) => {
  contracts = contracts && contracts.filter((c) => c.accepted && !c.fulfilled);

  if (!contracts) {
    return false;
  }

  if (contracts.length < 1) {
    return false;
  }

  const contract = contracts[0];
  const destination = contract.terms.deliver[0].destinationSymbol;
  if (destination !== waypoint.symbol) {
    return false;
  }

  const tradeSymbol = contract.terms.deliver[0].tradeSymbol;
  return ship && ship.cargo.inventory.find((i) => i.symbol == tradeSymbol) !== undefined;
}

export const isPinned = (pinnedContracts, id) => {
  return pinnedContracts && pinnedContracts.some(e => e == id);
}

export const hasAnyCargo = (ship) => {
  return ship && ship.cargo.inventory.length > 0;
}

// TODO:
// this functions works only with one contract active
// Make this functions woks if more contracts are active

export const tradeGoodInContract = (tradeSymbol, contracts) => {
  contracts = contracts.filter(c => c.accepted && !c.fulfilled);
  const contract = contracts && contracts[0];

  return contract && contract.terms.deliver.some(e => e.tradeSymbol == tradeSymbol);
}

export const isShipAction = (ship, action) => {
  if (!ship.action) {
    return false;
  }

  return ship.action.type != action;
}

export const isInTransit = (ship) => {
  if (!ship) {
    return false;
  }

  return ship.nav.status == 'IN_TRANSIT';
}

export const formatNumber = (number) => {
  return new Intl.NumberFormat('us-US').format(number);
}

export const avaragePriceOfShip = (shipSymbol, transactions) => {
  const transactionsOfShip = transactions.filter(e => e.shipSymbol == shipSymbol);
  let total = 0;

  if (transactionsOfShip.length > 0) {
    transactionsOfShip.map((ship) => total += ship.price);

    total = total / transactionsOfShip.length;
  }

  return total ? formatNumber(Math.round(total)) : 'Unknown';
}

export const getShipBySymbol = (shipSymbol, ships) => {
  const ship =  ships && ships.find(s => s.symbol == shipSymbol);

  return ship;
}